module.exports = __webpack_public_path__ + "static/media/Aaron Burr - 1796.dc129a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Aaron Burr - 1796.jpg
// module id = 425
// module chunks = 0